/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';

import {ApiConfig} from '../config/api-config';
import {AdnApiClientService} from '../common/controller/adn-api-client.service';

@Injectable({providedIn: 'root'})
export class LivePreviewApiService {
  constructor(private readonly client: AdnApiClientService, private readonly apiConfig: ApiConfig) {
  }

  create(
    viewUrl: string,
    networkId: string,
    teamId: string,
    layoutId: string,
    layoutParameters: any,
    width: number,
    height: number
  ): Observable<any> {
    return this.client.request({
      method: 'POST',
      url: this.apiConfig.getVersionedUri('livepreview/create'),
      params: {context: networkId},
      body: {networkId, layoutId, teamId, layoutParameters, viewUrl, width, height}
    });
  }
}
